/* 🤖 this file was generated by svg-to-ts */
export const matIconRepeatOne: {
  name: 'repeat-one';
  data: string;
} = {
  name: 'repeat-one',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M7 7h10v3l4-4-4-4v3H5v6h2V7zm10 10H7v-3l-4 4 4 4v-3h12v-6h-2v4zm-4-2V9h-1l-2 1v1h1.5v4H13z"/></svg>`
};
